import {LqbFundedLogsControllerName} from "../utils/names/controllerNames";
import {LqbLoggingController} from "./route/funded-logging";
import {LqbFundedLogServiceName} from "../utils/names/serviceNames";
import {LqbFundedLogService} from "./services/LqbFundedLogService";
import {FundedLoggingComponent} from "./components/funded_log/FundedLoggingComponent";
import LqbFundedLogModuleConfiguration from "./lqbFundedLoggingModuleConfiguration";


LqbFundedLogModuleConfiguration.createNewModule()
    .controller(LqbFundedLogsControllerName, LqbLoggingController.instance)
    .service(LqbFundedLogServiceName, LqbFundedLogService.instance)
    .component('fundedExecutionLog', FundedLoggingComponent.instance);